import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import './LayoutMain.css'

const LayoutMain = ({children}) => {
  return (
    <div className='LayoutMain'>
      <Navbar/>
        {children}
      <Footer/>
    </div>
  )
}

export default LayoutMain